import React, { useContext, useEffect, useState } from 'react';
import {
  CaretRightOutlined,
  EditFilled,
  LoadingOutlined,
  ArrowLeftOutlined as BackIcon,
} from '@ant-design/icons';
import { Select, Spin } from 'antd';

import { JourneySteps, ON_STATIC_METHODS } from '../../utils/static';
import './appbar.less';
import { Button, Modal } from 'antd';
import { AppContext, JourneyObjectModel } from '../../app';
import Moment from 'moment';
import { useRef } from 'react';
import openSnackBar from './SnackBar';
import { thirdPartyEnums } from '@Modules/admin/thirdParty/components/ThirdPartyTypes';
import _, { isNil } from 'lodash';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { journeyTypes } from '@Modules/engage/journey/model/JourneyTypes';
import { useIsParentProduct } from '@Utils/isParentProduct';
import {
  findOrbitMissionEventOccurrence,
  ORBIT_MISSION_START_EVENT_NAME,
  parseOrbitCallOsi,
  refreshAllOrbitCallSteps,
} from '../../utils/hooks';

const { confirm } = Modal;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const AppBar = (props) => {
  const appContext = useContext(AppContext);
  const inputTitleRef = useRef();

  const {
    journey,
    journeyId,
    newJourney,
    mode,
    publishAfterCreate,
    currentProduct,
    templateNames,
  } = props.data;

  const history = useHistory();
  const currentUser = useSelector((state) => state.account.auth.currentUser);
  const data = useSelector(
    (state) => state.engage.journey.successUpdateJourney
  );
  const loadingUpdate = useSelector(
    (state) => state.engage.journey.loadingUpdateJourney
  );

  const isParent = useIsParentProduct(currentUser);
  const [currentStep, setCurrentStep] = useState(0);
  const [name, setName] = useState(
    props.type === journeyTypes.RELAY
      ? 'Relay ' + Moment().format('YY-MM-DD.SSS')
      : props.type === journeyTypes.JOURNEY
      ? 'Journey ' + Moment().format('YY-MM-DD.SSS')
      : ''
  );
  const saveDraftButton = useRef();

  useEffect(() => {
    if (journey?.name) {
      setName(journey.name);
    }
  }, [journey]);
  useEffect(() => {
    if (props.data?.journeyId) {
      props.update(props.data.journeyId, mode);
    }
  }, [props.data?.journeyId, mode]);

  useEffect(() => {
    if (newJourney) {
      if (newJourney.id && publishAfterCreate) {
        props.launch({
          id: newJourney.id,
          body: Object.assign({}, appContext.journey, {
            name,
          }),
        });
      } else if (newJourney.id) {
        let currentJourney = { ...appContext.journey };
        if (
          appContext.journey &&
          appContext.journey.hasOwnProperty('steps') &&
          Object.keys(appContext.journey).length === 1
        ) {
          currentJourney = { ...JourneyObjectModel, ...currentJourney };
        }
        props.updateSubmit(
          {
            id: newJourney.id,
            body: Object.assign({}, currentJourney, { name }),
          },
          () => {
            props?.update(newJourney.id);
          }
        );
        if (isParent) history.goBack();
      }
    }
  }, [newJourney]);

  // Filter journey steps based on status and mode
  const getFilteredJourneySteps = () => {
    // If mode is 'view' and status is 'RUNNING' or 'PAUSED', show only Design and Preview steps

    if (mode === 'view' && journey?.status === 'RUNNING') {
      return JourneySteps.filter((step) => step.key === 'design');
    }

    if (mode === 'view' && journey?.status === 'PAUSED') {
      return JourneySteps.filter(
        (step) => step.key === 'design' || step.key === 'publish'
      );
    }
    // Otherwise, show all steps
    return JourneySteps;
  };

  const filteredJourneySteps = getFilteredJourneySteps();

  useEffect(() => {
    const cu_index = filteredJourneySteps.findIndex(
      (m) => m.key === props.currentStep
    );
    setCurrentStep(cu_index);
  }, [props.currentStep, filteredJourneySteps]);

  /**
   * Save journey to server
   * @param {*} status //publish or draft
   */
  // eslint-disable-next-line no-unused-vars

  const save = async (status) => {
    if (loadingUpdate) return;

    const jnId = newJourney?.id || journeyId;

    if (jnId) {
      // if created
      if (status === 'publish') {
        // HasTriggerMinimalStep
        let hasMinimalStep = true;
        if (!appContext.journey?.steps?.length) {
          hasMinimalStep = false;
        } else if (
          !appContext.journey.steps.find(
            (step) => step?.ui?.nodeType === 'TRIGGER'
          )
        ) {
          hasMinimalStep = false;
        }
        if (!hasMinimalStep) {
          openSnackBar('error', {
            message: 'Minimal Trigger error!',
            description: 'Please add at least one Trigger to this Journey',
          });
          console.error('Not has minimal step');
          return;
        }

        // Re-point Orbit Call omti templates before publish payload is sent
        syncRefreshedOrbitCallSteps();

        const cacheRefinerid = props.refineryCache();

        // console.log('test------', cacheRefinerid, appContext.journey);
        if (cacheRefinerid?.countUiEdge !== cacheRefinerid?.countServerEdge) {
          props.submitLog({
            level: 'WARN',
            message: `Found problem in data journey #${jnId}`,
          });
          openSnackBar('error', {
            message: 'Unexpected error!',
            description:
              'Please contact by admin! Found problem in data journey.',
          });
          return;
        }

        confirm({
          title: `Are you sure you want to publish the ${props.type.toLowerCase()}?`,
          onOk() {
            props.launch({
              id: jnId,
              body: Object.assign({}, data, {
                name,
              }),
            });
          },
          onCancel() {},
        });
      } else {
        const cacheRefinerid = props.refineryCache();
        // Clean step.ui.error
        const steps = cacheRefinerid?.data.steps?.map((step) => {
          delete step.ui.error;
          return step;
        });
        const body = Object.assign({}, cacheRefinerid?.data, {
          steps,
          name,
        });
        props.updateSubmit(
          {
            id: jnId,
            body: body,
            redirect: false,
            showNotificationMessage: true,
          },
          () => {
            props?.update(jnId);
          }
        );
        if (isParent) history.goBack();
      }
    } else {
      // if not created
      // NOTE: After created auto updated
      if (status === 'publish') {
        confirm({
          title: `Are you sure you want to publish the ${props.type.toLowerCase()}?`,
          onOk() {
            props.create({
              body: {
                name,
                type: props.type,
              },
              redirect: false,
              publishAfterCreate: true,
            });
          },
          onCancel() {},
        });
      } else {
        props.create({
          body: {
            name,
            type: props.type,
          },
          redirect: false,
          showNotificationMessage: true,
        });
      }
    }
  };

  /**
   * Journey design validation rules (all enforced when leaving Design step):
   * 1. All nodes that were added must be filled; if a node was created but not filled, show appropriate error. → validateJourneyNodes
   * 2. No isolated node (without connection to other nodes); there must be connections between nodes. → validateNodesConnectivity
   * 3. Multiple trigger nodes of the same type cannot connect to the same node (e.g. two "Occurrence of Event" cannot both connect to "Send Email"). → validateSingleTriggerPerNode
   * 4. Each output can connect to at most one node, except Trigger nodes (triggers can have multiple outgoing from same output). → validateSingleConnectionPerOutput
   * 5. All nodes can have more than one incoming connection, except End Journey (only one). → validateEndJourneySingleInput + onConnectDrop in root/index.js
   * 6. Different outputs of each node do not need to be connected (optional); no validation required.
   */

  /**
   * Rule 1: Validate if all nodes have required fields filled
   * @returns {Object} { isValid: boolean, errors: Array<{nodeId: string, nodeLabel: string, message: string}> }
   */
  const validateJourneyNodes = () => {
    const errors = [];
    const { steps } = appContext.journey || {};

    if (!steps || steps.length === 0) {
      return { isValid: true, errors: [] };
    }

    steps.forEach((step) => {
      const stepType = step.type;
      const stepId = step.id;
      const stepLabel = step.ui?.label || `State-${stepId}`;
      let isValid = true;
      let errorMessage = '';

      switch (stepType) {
        case 'EVENT_OCCURRENCE':
          if (!step.event) {
            isValid = false;
            errorMessage = 'Please select an event';
          }
          break;

        case 'IS_IN_SEGMENT':
          if (!step.segment) {
            isValid = false;
            errorMessage = 'Please select a segment';
          }
          break;

        case 'HAS_DONE_EVENT':
          if (!step.event) {
            isValid = false;
            errorMessage = 'Please select an event';
          }
          break;

        case 'CHECK_USER_ATTRIBUTE':
          if (!step.attribute && !step.ui?.predicate?.attribute) {
            isValid = false;
            errorMessage = 'Please select an attribute';
          }
          break;

        case 'IS_USER_REACHABLE':
          if (!step.channel) {
            isValid = false;
            errorMessage = 'Please select a channel';
          }
          break;

        case 'WAIT_FOR_TIME':
          if (!step.waitMinutes || step.waitMinutes === 0) {
            isValid = false;
            errorMessage = 'Please set wait time';
          }
          break;

        case 'WAIT_FOR_EVENT':
          if (!step.event) {
            isValid = false;
            errorMessage = 'Please select an event';
          }
          if (!step.waitMinutes || step.waitMinutes === 0) {
            isValid = false;
            errorMessage = 'Please set wait time';
          }
          break;

        case 'WAIT_FOR_DATE':
          if (!step.waitForAttributeType) {
            isValid = false;
            errorMessage = 'Please configure wait for date settings';
          } else if (step.waitForAttributeType === 'USER_ATTRIBUTE') {
            if (!step.userAttribute) {
              isValid = false;
              errorMessage = 'Please select a user attribute';
            }
          } else if (step.waitForAttributeType === 'EVENT_ATTRIBUTE') {
            if (!step.stepId || !step.eventAttribute) {
              isValid = false;
              errorMessage = 'Please select step and event attribute';
            }
          }
          break;

        case 'WAIT_FOR_TIME_SLOT':
          if (!step.timeSlots || step.timeSlots.length === 0) {
            isValid = false;
            errorMessage = 'Please configure time slots';
          }
          break;

        case 'CALL_API':
          if (step.ui?.key === 'ORBIT_CALL') {
            const osi = parseOrbitCallOsi(step.body).trim();
            if (!osi) {
              isValid = false;
              errorMessage = 'Please enter OSI for Orbit Call';
              break;
            }
            const orbitEventStep = findOrbitMissionEventOccurrence(
              steps,
              appContext.eventsContext
            );
            if (!orbitEventStep) {
              isValid = false;
              errorMessage = `Orbit Call requires an Occurrence of Event for ${ORBIT_MISSION_START_EVENT_NAME}`;
            }
          } else if (!step.url || step.url.trim() === '') {
            isValid = false;
            errorMessage = 'Please enter API URL';
          }
          break;

        case 'SPECIFIC_USERS': {
          // Required: staticAttribute (type selection - Email Address, User Identifier, or Phone Number)
          if (!step.staticAttribute) {
            isValid = false;
            errorMessage =
              'Please select a type (Email Address, User Identifier, or Phone Number)';
          }
          // Required: staticFile (CSV file upload)
          if (!step.staticFile) {
            isValid = false;
            errorMessage = 'Please upload a CSV file';
          }
          // Optional: collapseField (Remove duplicate) - no validation needed
          break;
        }

        case 'ENTER_EXIT_SEGMENT':
          if (!step.segment) {
            isValid = false;
            errorMessage = 'Please select a segment';
          }
          if (step.repeatType && (!step.repeatTime || !step.repeatEvery)) {
            isValid = false;
            errorMessage = 'Please fill all recurring fields';
          }
          break;

        case 'SET_USER_ATTRIBUTE':
          if (!step.actionType) {
            isValid = false;
            errorMessage = 'Please select action type';
          } else if (step.actionType === 'EXISTING_ATTRIBUTE') {
            if (!step.attributeId) {
              isValid = false;
              errorMessage = 'Please select an attribute';
            }
            if (!step.attributeType) {
              isValid = false;
              errorMessage = 'Please set attribute type';
            }
            if (
              step.attributeValue === null ||
              step.attributeValue === undefined ||
              step.attributeValue === ''
            ) {
              isValid = false;
              errorMessage = 'Please set attribute value';
            }
          } else if (step.actionType === 'NEW_ATTRIBUTE') {
            if (!step.attributeName) {
              isValid = false;
              errorMessage = 'Please enter attribute name';
            }
            if (!step.attributeType) {
              isValid = false;
              errorMessage = 'Please select attribute type';
            }
            if (
              step.attributeValue === null ||
              step.attributeValue === undefined ||
              step.attributeValue === ''
            ) {
              isValid = false;
              errorMessage = 'Please set attribute value';
            }
          }
          break;

        case 'CHANGE_IN_USER_ATTRIBUTE': {
          // Required: attribute
          if (!step.attribute) {
            isValid = false;
            errorMessage = 'Please select a user attribute';
          }
          // Required: valueChangeType or attributeType (Any or Specific)
          const valueChangeType = step.valueChangeType || step.attributeType;
          if (!valueChangeType) {
            isValid = false;
            errorMessage = 'Please select change type (Any or Specific)';
          }
          // If Specific is selected, predicates are required
          if (valueChangeType === 'SPECIFIC') {
            if (!step.predicates || step.predicates.length === 0) {
              isValid = false;
              errorMessage =
                'Please add at least one predicate when Specific is selected';
            } else {
              // Validate that each predicate has type and required fields
              const hasInvalidPredicate = step.predicates.some((pred) => {
                if (
                  !pred.type ||
                  (pred.type !== 'NEW_VALUE' && pred.type !== 'OLD_VALUE')
                ) {
                  return true;
                }
                // Check if predicate has required fields (operator and values)
                if (!pred.operator) {
                  return true;
                }
                if (pred.operator !== 'IS_NOT_EMPTY') {
                  if (pred.operator === 'BETWEEN') {
                    return (
                      _.isNull(pred.greaterThan) && _.isNull(pred.lessThan)
                    );
                  } else if (!pred.stringValue) {
                    return true;
                  }
                }
                return false;
              });
              if (hasInvalidPredicate) {
                isValid = false;
                errorMessage = 'Please fill all required fields in predicates';
              }
            }
          }
          break;
        }

        case 'SEND_SMS':
        case 'SEND_EMAIL':
        case 'SEND_PUSH':
        case 'SEND_WEB_PUSH':
        case 'SEND_CUSTOM':
        case 'SEND_IN_APP':
        case 'SEND_ON_SITE':
        case 'SEND_WHATSAPP':
          if (!step.communication) {
            isValid = false;
            errorMessage = 'Please select or create a campaign';
          }
          break;

        case 'TRAFFIC_SPLITTER':
          if (!step.on || step.on.length === 0) {
            isValid = false;
            errorMessage = 'Please configure traffic splitter connections';
          }
          break;

        case 'BUSINESS_EVENT_OCCURRENCE':
          if (!step.businessEvent) {
            isValid = false;
            errorMessage = 'Please select a business event';
          }
          break;

        case 'END_JOURNEY':
        case 'PLACE_HOLDER':
          // No validation needed for these types
          break;

        default:
          // Unknown step type, skip validation
          break;
      }

      if (!isValid) {
        errors.push({
          nodeId: stepId,
          nodeLabel: stepLabel,
          message: errorMessage,
        });
      }
    });

    return {
      isValid: errors.length === 0,
      errors,
    };
  };

  /**
   * Rule 2: Validate if all nodes are connected to at least one other node (no isolated nodes)
   * @returns {Object} { isValid: boolean, errors: Array<{nodeId: string, nodeLabel: string, message: string}> }
   */
  const validateNodesConnectivity = () => {
    const errors = [];
    const { steps } = appContext.journey || {};

    if (!steps || steps.length === 0) {
      return { isValid: true, errors: [] };
    }

    // Every node must be connected to at least one other node. A single node has no other node to connect to.
    if (steps.length === 1) {
      const step = steps[0];
      if (step.type === 'PLACE_HOLDER') {
        return { isValid: true, errors: [] };
      }
      const stepLabel = step.ui?.label || `State-${step.id}`;
      return {
        isValid: false,
        errors: [
          {
            nodeId: step.id,
            nodeLabel: stepLabel,
            message:
              'Every node must be connected to another node. Add at least one more node and connect it.',
          },
        ],
      };
    }

    steps.forEach((step) => {
      const stepId = step.id;
      const stepLabel = step.ui?.label || `State-${stepId}`;
      const stepType = step.type;

      // Skip validation for PLACE_HOLDER
      if (stepType === 'PLACE_HOLDER') {
        return;
      }

      // Check if node has any outgoing connections
      let hasOutgoingConnection = false;
      ON_STATIC_METHODS.forEach((method) => {
        if (
          step[method] &&
          Array.isArray(step[method]) &&
          step[method].length > 0
        ) {
          hasOutgoingConnection = true;
        }
      });

      // Check if node has any incoming connections
      // A node has incoming connection if it appears in any other node's outgoing connections
      let hasIncomingConnection = false;
      steps.forEach((otherStep) => {
        if (otherStep.id !== stepId) {
          ON_STATIC_METHODS.forEach((method) => {
            if (
              otherStep[method] &&
              Array.isArray(otherStep[method]) &&
              otherStep[method].some(
                (targetId) => targetId + '' === stepId + ''
              )
            ) {
              hasIncomingConnection = true;
            }
          });
        }
      });

      // Check if node is a TRIGGER type
      const isTriggerNode = step.ui?.nodeType === 'TRIGGER';

      // Check if node is END_JOURNEY type
      const isEndJourneyNode = stepType === 'END_JOURNEY';

      // Validation rules:
      // 1. Trigger nodes must have at least one outgoing connection (unless it's the only node)
      // 2. END_JOURNEY nodes must have at least one incoming connection
      // 3. Other nodes must have at least one incoming OR outgoing connection
      if (isTriggerNode) {
        if (!hasOutgoingConnection && steps.length > 1) {
          errors.push({
            nodeId: stepId,
            nodeLabel: stepLabel,
            message:
              'Trigger node must be connected to at least one other node',
          });
        }
      } else if (isEndJourneyNode) {
        if (!hasIncomingConnection) {
          errors.push({
            nodeId: stepId,
            nodeLabel: stepLabel,
            message:
              'End Journey node must have at least one incoming connection',
          });
        }
      } else {
        // Other nodes must be connected (either incoming or outgoing)
        if (!hasIncomingConnection && !hasOutgoingConnection) {
          errors.push({
            nodeId: stepId,
            nodeLabel: stepLabel,
            message:
              'Node must be connected to at least one other node (must have at least one incoming or outgoing connection)',
          });
        }
      }
    });

    return {
      isValid: errors.length === 0,
      errors,
    };
  };

  /**
   * Rule 3: Multiple trigger nodes of the same type cannot be connected to the same node.
   * E.g. two "Occurrence of Event" triggers cannot both connect to the same "Send Email" node.
   */
  const validateSingleTriggerPerNode = () => {
    const errors = [];
    const { steps } = appContext.journey || {};

    if (!steps || steps.length === 0) {
      return { isValid: true, errors: [] };
    }

    steps.forEach((step) => {
      const stepId = step.id;
      const stepLabel = step.ui?.label || `State-${stepId}`;
      const isTriggerNode = step.ui?.nodeType === 'TRIGGER';

      if (isTriggerNode) return;

      // Collect trigger types (e.g. EVENT_OCCURRENCE, ENTER_EXIT_SEGMENT) that connect to this node
      const triggerTypesConnecting = [];
      steps.forEach((otherStep) => {
        if (otherStep.id === stepId) return;
        const isOtherTrigger = otherStep.ui?.nodeType === 'TRIGGER';
        if (!isOtherTrigger) return;

        const triggerConnectsToThis = ON_STATIC_METHODS.some((method) => {
          return (
            otherStep[method] &&
            Array.isArray(otherStep[method]) &&
            otherStep[method].some((targetId) => targetId + '' === stepId + '')
          );
        });
        if (triggerConnectsToThis) triggerTypesConnecting.push(otherStep.type);
      });

      // Check if same trigger type appears more than once (e.g. two EVENT_OCCURRENCE)
      const typeCounts = {};
      triggerTypesConnecting.forEach((t) => {
        typeCounts[t] = (typeCounts[t] || 0) + 1;
      });
      const duplicateType = Object.keys(typeCounts).find(
        (t) => typeCounts[t] > 1
      );
      if (duplicateType) {
        errors.push({
          nodeId: stepId,
          nodeLabel: stepLabel,
          message:
            'Multiple triggers of the same type cannot be connected to this node. Only one trigger of each type can connect here.',
        });
      }
    });

    return {
      isValid: errors.length === 0,
      errors,
    };
  };

  /**
   * Rule 4: Each output (e.g. onSend, onYes) can connect to at most one node; e.g. onSend cannot have multiple outgoing connections.
   * Exception: Trigger nodes can have multiple outgoing connections from the same output (e.g. one trigger "on" to multiple nodes).
   */
  const validateSingleConnectionPerOutput = () => {
    const errors = [];
    const { steps } = appContext.journey || {};

    if (!steps || steps.length === 0) {
      return { isValid: true, errors: [] };
    }

    steps.forEach((step) => {
      const stepId = step.id;
      const stepLabel = step.ui?.label || `State-${stepId}`;
      const stepType = step.type;

      if (stepType === 'PLACE_HOLDER') return;

      // Trigger nodes: no limit on outgoing connections from the same output
      if (step.ui?.nodeType === 'TRIGGER') return;

      // TRAFFIC_SPLITTER has multiple outputs in "on" by design (one per branch)
      const isTrafficSplitter = stepType === 'TRAFFIC_SPLITTER';

      ON_STATIC_METHODS.forEach((method) => {
        const targets = step[method];
        if (targets && Array.isArray(targets) && targets.length > 1) {
          if (isTrafficSplitter && method === 'on') return;
          errors.push({
            nodeId: stepId,
            nodeLabel: stepLabel,
            message: `Output "${method}" can only be connected to one node. Remove extra connections.`,
          });
        }
      });
    });

    return {
      isValid: errors.length === 0,
      errors,
    };
  };

  /**
   * Rule 5: All nodes can have more than one incoming connection, except End Journey.
   * End Journey node can have only one incoming connection.
   */
  const validateEndJourneySingleInput = () => {
    const errors = [];
    const { steps } = appContext.journey || {};

    if (!steps || steps.length === 0) {
      return { isValid: true, errors: [] };
    }

    const endJourneySteps = steps.filter((s) => s.type === 'END_JOURNEY');

    endJourneySteps.forEach((step) => {
      const stepId = step.id;
      const stepLabel = step.ui?.label || `State-${stepId}`;

      let incomingCount = 0;
      steps.forEach((otherStep) => {
        if (otherStep.id === stepId) return;
        ON_STATIC_METHODS.forEach((method) => {
          if (
            otherStep[method] &&
            Array.isArray(otherStep[method]) &&
            otherStep[method].some((targetId) => targetId + '' === stepId + '')
          ) {
            incomingCount += 1;
          }
        });
      });

      if (incomingCount > 1) {
        errors.push({
          nodeId: stepId,
          nodeLabel: stepLabel,
          message: 'End Journey node can only have one incoming connection.',
        });
      }
    });

    return {
      isValid: errors.length === 0,
      errors,
    };
  };

  const syncRefreshedOrbitCallSteps = () => {
    const updated = refreshAllOrbitCallSteps(
      appContext.journey?.steps,
      appContext.eventsContext
    );
    updated.forEach((step) => {
      appContext.syncCache('update-step', step);
    });
  };

  const goNext = async () => {
    if (props.currentStep === 'publish') {
      save('publish');
    } else {
      // Validate all nodes before going to next step
      if (props.currentStep === 'design') {
        // Validate required fields
        const validation = validateJourneyNodes();
        if (!validation.isValid) {
          const errorMessages = validation.errors
            .map((err) => `${err.nodeLabel}: ${err.message}`)
            .join('\n');
          openSnackBar('error', {
            message: 'Please complete all node configurations',
            description: `The following nodes have missing required fields:\n${errorMessages}`,
          });
          return;
        }

        // Keep Orbit Call omti templates pointed at the current EVENT_OCCURRENCE step
        syncRefreshedOrbitCallSteps();

        // Validate nodes connectivity
        const connectivityValidation = validateNodesConnectivity();
        if (!connectivityValidation.isValid) {
          const errorMessages = connectivityValidation.errors
            .map((err) => `${err.nodeLabel}: ${err.message}`)
            .join('\n');
          openSnackBar('error', {
            message: 'All nodes must be connected',
            description: `The following nodes are not connected:\n${errorMessages}`,
          });
          return;
        }

        // Rule 3: No two triggers to same node
        const triggerValidation = validateSingleTriggerPerNode();
        if (!triggerValidation.isValid) {
          const errorMessages = triggerValidation.errors
            .map((err) => `${err.nodeLabel}: ${err.message}`)
            .join('\n');
          openSnackBar('error', {
            message: 'Invalid trigger connections',
            description: errorMessages,
          });
          return;
        }

        // Rule 4: Each output at most one connection
        const outputValidation = validateSingleConnectionPerOutput();
        if (!outputValidation.isValid) {
          const errorMessages = outputValidation.errors
            .map((err) => `${err.nodeLabel}: ${err.message}`)
            .join('\n');
          openSnackBar('error', {
            message: 'Invalid output connections',
            description: errorMessages,
          });
          return;
        }

        // Rule 5: End Journey only one incoming
        const endJourneyValidation = validateEndJourneySingleInput();
        if (!endJourneyValidation.isValid) {
          const errorMessages = endJourneyValidation.errors
            .map((err) => `${err.nodeLabel}: ${err.message}`)
            .join('\n');
          openSnackBar('error', {
            message: 'Invalid End Journey connections',
            description: errorMessages,
          });
          return;
        }
      }

      // detect nextStep if exist
      const nextStepI =
        currentStep + 1 > filteredJourneySteps.length - 1
          ? currentStep
          : currentStep + 1;

      if (nextStepI !== currentStep) {
        // get nextStep
        const nextStep = filteredJourneySteps.find((m, i) => nextStepI === i);
        goTo_(nextStep.key, nextStepI, false);
      }
    }
  };

  const goTo_ = (page, i, redirect) => {
    setCurrentStep(i);
    props.goNextStep(page);
    save('draft', redirect);
  };

  // eslint-disable-next-line no-unused-vars
  const goTo = (page, i, redirect) => {
    if (props.loading) return;

    // Validate all nodes before going to next step (only when leaving design step)
    if (props.currentStep === 'design' && page !== 'design') {
      // Validate required fields
      const validation = validateJourneyNodes();
      if (!validation.isValid) {
        const errorMessages = validation.errors
          .map((err) => `${err.nodeLabel}: ${err.message}`)
          .join('\n');
        openSnackBar('error', {
          message: 'Please complete all node configurations',
          description: `The following nodes have missing required fields:\n${errorMessages}`,
        });
        return;
      }

      // Keep Orbit Call omti templates pointed at the current EVENT_OCCURRENCE step
      syncRefreshedOrbitCallSteps();

      // Validate nodes connectivity
      const connectivityValidation = validateNodesConnectivity();
      if (!connectivityValidation.isValid) {
        const errorMessages = connectivityValidation.errors
          .map((err) => `${err.nodeLabel}: ${err.message}`)
          .join('\n');
        openSnackBar('error', {
          message: 'All nodes must be connected',
          description: `The following nodes are not connected:\n${errorMessages}`,
        });
        return;
      }

      // Rule 3: No two triggers to same node
      const triggerValidation = validateSingleTriggerPerNode();
      if (!triggerValidation.isValid) {
        const errorMessages = triggerValidation.errors
          .map((err) => `${err.nodeLabel}: ${err.message}`)
          .join('\n');
        openSnackBar('error', {
          message: 'Invalid trigger connections',
          description: errorMessages,
        });
        return;
      }

      // Rule 4: Each output at most one connection
      const outputValidation = validateSingleConnectionPerOutput();
      if (!outputValidation.isValid) {
        const errorMessages = outputValidation.errors
          .map((err) => `${err.nodeLabel}: ${err.message}`)
          .join('\n');
        openSnackBar('error', {
          message: 'Invalid output connections',
          description: errorMessages,
        });
        return;
      }

      // Rule 5: End Journey only one incoming
      const endJourneyValidation = validateEndJourneySingleInput();
      if (!endJourneyValidation.isValid) {
        const errorMessages = endJourneyValidation.errors
          .map((err) => `${err.nodeLabel}: ${err.message}`)
          .join('\n');
        openSnackBar('error', {
          message: 'Invalid End Journey connections',
          description: errorMessages,
        });
        return;
      }
    }

    setCurrentStep(i);
    props.goNextStep(page);
  };

  const changeStatus = (status) => {
    switch (status) {
      case 'stop':
        confirm({
          title: 'Do you want to stop this journey?',
          onOk() {
            props.stop(journeyId);
          },
          onCancel() {},
        });
        break;
      case 'start':
        confirm({
          title: 'Do you want to start this journey?',
          onOk() {
            props.launch({
              id: journeyId,
              body: Object.assign({}, appContext.journey, {
                name,
              }),
            });
          },
          onCancel() {},
        });
        break;
      case 'pause':
        confirm({
          title: 'Do you want to sunset this journey?',
          onOk() {
            props.pause(journeyId);
          },
          onCancel() {},
        });
        break;
    }
  };

  const goEdit = (e) => {
    e.preventDefault();
    const url = props.history.location.pathname.replace('/report', '/view');
    props.history.push(url);
  };

  const handleTemplateNameChange = (value) => {
    setName(value);
  };

  // Check if we're on the new journey page
  const isNewJourney = !journeyId || history.location.pathname.includes('/new');

  return (
    <div
      className={
        props.currentStep === 'design' ? 'appbar' : 'appbar appbar__margin'
      }
    >
      <div className={'appbar__header'}>
        <div className={'header__left'}>
          {mode === 'report' ? (
            <span
              onClick={() => props.history.goBack()}
              className={'appbar__journey-back'}
            >
              <BackIcon style={{ fontSize: '1.2em' }} />
            </span>
          ) : (
            ''
          )}
          {mode !== 'report' &&
            currentProduct?.thirdPartyOption !== thirdPartyEnums.PARENT && (
              <EditFilled
                className={'appbar__header__icon'}
                onClick={() => inputTitleRef.current.focus()}
              />
            )}
          {currentProduct?.thirdPartyOption === thirdPartyEnums.PARENT && (
            <div>
              <span> TYPE: </span>
              <Select
                className={'appbar__name__template'}
                onChange={handleTemplateNameChange}
                disabled={!isNil(journey?.name)}
                value={name}
              >
                {templateNames?.map((templateName) => {
                  return (
                    <Select.Option
                      key={templateName.name}
                      value={templateName.name}
                    >
                      {templateName.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          )}
          {currentProduct?.thirdPartyOption !== thirdPartyEnums.PARENT && (
            <input
              disabled={mode === 'report'}
              ref={inputTitleRef}
              className={'appbar__name'}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          )}
        </div>
        <div className={'appbar__tools'}>
          <div>
            {(props.loading || props.loadingFitView) && (
              <Spin indicator={antIcon} />
            )}
            {/* {mode !== 'report' && (
              <Tooltip
                title={`Auto Save (every 1 min.) is ${autoSave ? 'ON' : 'OFF'}`}
              >
                <Switch
                  defaultChecked
                  style={{ width: 30 }}
                  value={false}
                  onChange={(val) => {
                    autoSave.current = val;
                  }}
                />
              </Tooltip>
            )} */}
            {/* Combined button logic for all modes */}
            {mode !== 'report' && (
              <>
                {/* Show only SAVE button when status is RUNNING */}
                {journey?.status === 'RUNNING' && (
                  <Button
                    onClick={save}
                    type={
                      currentProduct?.thirdPartyOption ===
                      thirdPartyEnums.PARENT
                        ? 'primary'
                        : 'default'
                    }
                    disabled={props.loading || loadingUpdate}
                    shape="round"
                    ref={saveDraftButton}
                  >
                    SAVE
                  </Button>
                )}

                {/* Show only SAVE DRAFT button when status is PAUSED or for new journeys */}
                {(journey?.status === 'PAUSED' ||
                  journey?.status === 'DRAFT' ||
                  isNewJourney) && (
                  <Button
                    onClick={save}
                    type={
                      isNewJourney
                        ? 'default'
                        : currentProduct?.thirdPartyOption ===
                          thirdPartyEnums.PARENT
                        ? 'primary'
                        : 'default'
                    }
                    disabled={props.loading || loadingUpdate}
                    shape="round"
                    ref={saveDraftButton}
                  >
                    SAVE DRAFT
                  </Button>
                )}

                {/* NEXT/PUBLISH Button - show for new journeys, when not RUNNING, or when PAUSED and on publish step */}
                {(isNewJourney ||
                  (journey?.status !== 'RUNNING' &&
                    currentProduct?.thirdPartyOption !==
                      thirdPartyEnums.PARENT) ||
                  (journey?.status === 'PAUSED' &&
                    props.currentStep === 'publish' &&
                    currentProduct?.thirdPartyOption !==
                      thirdPartyEnums.PARENT)) && (
                  <Button
                    type="primary"
                    shape="round"
                    disabled={props.loading || loadingUpdate}
                    onClick={goNext}
                  >
                    {props.currentStep === 'publish' ? 'PUBLISH' : 'NEXT'}
                  </Button>
                )}
              </>
            )}
            {mode === 'report' && (
              <span className={'appbar__status'}>
                {!props.loading && (
                  <span>
                    &nbsp;STATUS:&nbsp;
                    <span className={`${'appbar__status--' + journey?.status}`}>
                      {journey?.status}
                    </span>
                    &nbsp;
                    <span className={`${'appbar__status--' + journey?.status}`}>
                      {journey?.status === 'PAUSED' ? (
                        <a onClick={goEdit}>(edit)</a>
                      ) : (
                        ''
                      )}
                    </span>
                  </span>
                )}
                <span>
                  {(journey?.status === 'PAUSED' ||
                    journey?.status === 'STOPPED') && (
                    <Button
                      disabled={props.loading}
                      onClick={() => changeStatus('start')}
                    >
                      PLAY
                    </Button>
                  )}
                  {(journey?.status === 'RUNNING' ||
                    journey?.status === 'UPCOMING' ||
                    journey?.status === 'ENDED') && (
                    <Button
                      disabled={props.loading}
                      onClick={() => changeStatus('stop')}
                    >
                      STOP
                    </Button>
                  )}
                  {(journey?.status === 'RUNNING' ||
                    journey?.status === 'UPCOMING' ||
                    journey?.status === 'ENDED') && (
                    <Button
                      disabled={props.loading}
                      onClick={() => changeStatus('pause')}
                    >
                      PAUSE
                    </Button>
                  )}
                  {journey?.status === 'RUNNING' && (
                    <Button
                      disabled={props.loading}
                      onClick={goEdit}
                      style={{ marginLeft: '10px' }}
                    >
                      EDIT
                    </Button>
                  )}
                </span>
              </span>
            )}
          </div>
        </div>
      </div>
      {mode !== 'report' && (
        <div
          className={'appbar__journey-steps'}
          hidden={currentProduct?.thirdPartyOption === thirdPartyEnums.PARENT}
        >
          <div
            onClick={() => props.history.goBack()}
            className={'appbar__journey-back'}
          >
            <BackIcon style={{ fontSize: '1.2em' }} />
          </div>
          {filteredJourneySteps?.map((step, index) => (
            <div
              className={
                'journey-step' +
                (currentStep === index ? ' active' : '') +
                (props.loading ? ' step--on-loading' : '')
              }
              key={index}
              onClick={() => goTo(step.key, index, false)}
            >
              <div className={'journey-step__name'}>{step.name}</div>
              {filteredJourneySteps.length > index + 1 && (
                <CaretRightOutlined style={{ color: '#eaeaea' }} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default AppBar;
